// Page copy that is not a list of records: hero slides, about texts, highlights, mission/vision.
// Each export maps to one section so a future CMS can edit them independently.

export const heroSlides = [
  {
    id: 1,
    image: "/assets/images/sliders/1.jpg",
    title: "Compassionate Mental Health Care",
    desc: "The health and recovery of our patients and their families will always be our priority, so we follow ethical and evidence-based treatment practices.",
    features: [
      { icon: "icon-heart", title: "Psychiatry" },
      { icon: "icon-medicine", title: "Medication" },
      { icon: "icon-heart2", title: "Therapy" },
      { icon: "icon-blood-test", title: "Wellness" },
    ],
  },
  {
    id: 2,
    image: "/assets/images/sliders/2.jpg",
    title: "Complete Psychiatric Treatment",
    desc: "The health and recovery of our patients and their families will always be our priority, so we ensure safe, confidential, and supportive care.",
    features: [
      { icon: "icon-heart", title: "Addiction" },
      { icon: "icon-medicine", title: "Counseling" },
      { icon: "icon-heart2", title: "Recovery" },
      { icon: "icon-blood-test", title: "Support" },
    ],
  },
];

export const homeContactBoxes = {
  emergency: {
    title: "Emergency Cases",
    desc: "Please feel free to contact our friendly reception staff with any general or medical enquiry.",
  },
  timetable: {
    title: "Doctors Timetable",
    desc: "Qualified doctors available six days a week, view our timetable to make an appointment.",
  },
  hoursTitle: "Opening Hours",
};

export const aboutIntro = {
  title: "Compassionate Mental Health & Addiction Recovery Care",
  lead: "Unity Health Centre is a specialized mental health, psychiatric, and addiction treatment hospital committed to ethical care, confidentiality, and long-term recovery through evidence-based and holistic treatment approaches.",
  paragraphs: [
    "Unity Health Centre is a professional mental health and addiction treatment hospital dedicated to ethical care, confidentiality, and long-term recovery. Our experienced team ensures compassionate treatment following international standards.",
    "Unity Health Centre provides comprehensive psychiatric care, addiction rehabilitation, and psychological counseling in a safe and supportive environment. Our multidisciplinary team ensures personalized treatment plans for every patient, promoting dignity, healing, and sustainable recovery.",
  ],
  highlights: [
    "Experienced Psychiatrists & Specialists",
    "Evidence-Based Treatment Protocols",
    "Separate & Secure Units",
    "Confidential & Ethical Care",
    "Affordable Treatment Packages",
    "Family-Centered Recovery Approach",
  ],
  homeImage: "/assets/images/about/2.jpg",
  pageImage: "/assets/images/about/1.jpg",
};

export const supportBlock = {
  title: "Supporting Mental Health & Recovery",
  desc: "Our team is committed to making every interaction respectful, clear, supportive, and compassionate.",
  quote:
    "We provide ethical psychiatric care guided by medical standards and compassion. We support addiction recovery through structured treatment and therapy programs. We help individuals and families build stability, healing, and long-term wellness.",
  signature: "Unity Health Centre",
  signatureRole: "Management Team",
};

export const bookingPanel = {
  title: "Book An Appointment",
  desc: "Please feel welcome to contact our friendly reception staff with any general or medical enquiry. Our doctors will receive or return any urgent calls.",
};

export const aboutFeatures = [
  {
    title: "Introduction",
    icon: "icon-heart",
    desc: "Over the past two decades, mental illness and substance abuse have increased significantly, affecting individuals, families, and communities across Bangladesh. Unity Health Centre was established to respond to this growing need by delivering professional, ethical, and compassionate mental healthcare services focused on long-term recovery and well-being.",
  },
  {
    title: "Objectives",
    icon: "icon-doctor",
    desc: "Unity Health Centre aims to provide high-quality psychiatric and addiction treatment through medical, psychological, and holistic care approaches. Our objectives include supporting sustainable recovery, reducing stigma surrounding mental illness, and empowering patients and families through education, guidance, and continuous emotional support.",
  },
  {
    title: "Excellence",
    icon: "icon-ambulance",
    desc: "Unity Health Centre maintains excellence by following international standards of treatment and care. Our services are delivered by qualified psychiatrists, psychologists, addiction counselors, trained nurses, and skilled attendants, supported by secure inpatient facilities and comprehensive holistic wellness programs.",
  },
];

export const whyChoose = {
  subtitle: "Caring For The Health Of You And Your Family.",
  title: "Why Choose Unity Health Centre?",
  points: aboutIntro.highlights,
  steps: [
    {
      number: "01",
      icon: "icon-health-report",
      title: "Mission",
      desc: "To become a benchmark of excellence in mental healthcare. To provide affordable, ethical, and patient-centric service. To ensure long-term recovery and relapse prevention",
    },
    {
      number: "02",
      icon: "icon-dna",
      title: "Vision",
      desc: "To be recognized as one of the most trusted mental health and rehabilitation centres in Bangladesh, delivering world-class care with compassion and integrity.",
    },
  ],
  cta: {
    title: "True Healthcare For Your Family!",
    desc: "Serve the community by improving the quality of life through better health.",
    button: { label: "Our Packages", to: "/packages" },
  },
};

export const appointmentAbout = {
  title: "Compassionate Mental Health Care",
  lead: "We work closely with patients to develop personalized psychiatric and addiction treatment plans. When needed, we also guide families with referrals and continued care support.",
  desc: "Unity Health Centre is committed to providing ethical, confidential, and patient-centered mental healthcare. Our goal is to promote healing, dignity, and long-term recovery through evidence-based treatment and compassionate support.",
  points: [
    "We conduct comprehensive psychiatric assessments to understand mental health conditions and treatment needs.",
    "Our experienced psychiatrists, psychologists, and care staff manage a wide range of mental health and addiction disorders.",
    "We provide continuous care and rehabilitation support, from diagnosis to recovery and relapse prevention.",
  ],
};

export const contactPanel = {
  title: "How Can We Help?",
  desc: "Please feel welcome to contact our friendly reception staff with any general or medical enquiry. Our doctors will receive or return any urgent calls.",
  quickTitle: "Quick Contacts",
  quickDesc: "Please feel free to contact our friendly staff with any medical enquiry.",
};

export const emergencyWidget = {
  title: "Emergency Cases",
  desc: "Please feel welcome to contact our friendly reception staff with any general or medical enquiry call us.",
};

export const emergencyPopup = {
  desc: "Please feel free to contact our friendly reception staff with any general or medical enquiry.",
};

// Section headings / subtitles exactly as on the original site
export const sectionTitles = {
  homePackages: { title: "Our Packages" },
  homeServices: { title: "The Best Services We Offer" },
  homeConsultants: { title: "MEET OUR CONSULTANTS" },
  homeBlogs: { title: "LATEST BLOGS" },
  packagesPage: { title: "Our Packages", subtitle: "The Best Packages We Offer" },
  servicesPage: { title: "Our Services", subtitle: "Explore The Best Services We Offer" },
  doctorsPage: { title: "Our Consultants", subtitle: "Meet Our Consultants Team" },
  galleryPage: { title: "Our Gallery", subtitle: "Explore Our Images, Videos & Clients" },
  blogPage: { title: "Our Blogs", subtitle: "Explore News & Feed" },
  management: { title: "Meet Our Management Team", subtitle: "Our Administration and Support Staff" },
};
